import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionSteps } from "../../components/misc/Headings";
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Header from "../../components/headers/MainHeader";
import Footer from "../../components/footers/MainFooterWithLinks";
import { useTranslation } from "react-i18next";

import DesignIllustration from "../../images/CustomReg.png";
import Banner2 from "../../images/img/SecondBannerCustoms.svg";
import CustomImage from "../../images/img/BannerCustoms.svg";

const Container = tw.div`relative`;
const Heading = tw(SectionSteps)`font-extrabold text-3xl sm:text-3xl lg:text-3xl text-left leading-tight`;
const Paragraph = styled.p`${tw`mt-4 text-base xl:text-lg my-2 lg:my-4 text-gray-700`}`;
const SectionContainer = styled.div`${tw`py-8 px-4 lg:px-8 mb-8 bg-gray-100 rounded-lg`}`;
const List = styled.ul`${tw`list-disc pl-5 my-4`}`;
const ListItem = styled.li`${tw`text-lg my-2`} color:#2d2d2d;`;
const Content = tw.div`max-w-screen-xl mx-auto py-8 lg:py-12`;
const HeadingColumn = tw.div`text-center xl:text-left max-w-lg xl:max-w-none mx-auto xl:mx-0`;
const InfoSection = styled.div`${tw`flex flex-col lg:flex-row items-center justify-center my-8`} font-size:22px; line-height:1.5; text-align:center;`;
const ImageContainer = styled.div`${tw`flex-shrink-0 lg:mr-8`} img{${tw`w-80 h-80`}}`;
const InfoText = styled.div`${tw`text-2xl leading-snug`} color:#243e63;`;
const HighlightedInfoText = styled.span`font-weight:bold; color:#0abd19;`;

export default function CustomsRulesPage() {
    const { t } = useTranslation();

    return (
        <AnimationRevealPage>
            <Header
                heading={t("customsPage.header.title")}
                paragraph={t("customsPage.header.paragraph")}
                imageSrc={DesignIllustration}
                roundedHeaderButton={false}
            />

            <Container>
                <Content>
                    <HeadingColumn>
                        <SectionContainer>
                            <Heading>{t("customsPage.intro.title")}</Heading>
                            <Paragraph>{t("customsPage.intro.text")}</Paragraph>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.declaration.title")}</Heading>
                            <Paragraph>{t("customsPage.declaration.text")}</Paragraph>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.limits.title")}</Heading>
                            <Paragraph>{t("customsPage.limits.text")}</Paragraph>

                            <InfoSection>
                                <ImageContainer>
                                    <img src={CustomImage} alt={t("customsPage.alts.customsInfo")} />
                                </ImageContainer>
                                <InfoText>
                                    <strong style={{ color:"#192b45", fontSize:"30px", display:"block", marginBottom:"10px" }}>
                                        {t("customsPage.limits.noteTitle")}
                                    </strong>
                                    <HighlightedInfoText>{t("customsPage.limits.noteText")}</HighlightedInfoText>
                                </InfoText>
                            </InfoSection>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.quantity.title")}</Heading>
                            <Paragraph>{t("customsPage.quantity.text")}</Paragraph>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.documents.title")}</Heading>
                            <Paragraph>{t("customsPage.documents.intro")}</Paragraph>
                            <List>
                                <ListItem>{t("customsPage.documents.items.passport")}</ListItem>
                                <ListItem>{t("customsPage.documents.items.birthCert")}</ListItem>
                                <ListItem>{t("customsPage.documents.items.iin")}</ListItem>
                                <ListItem>{t("customsPage.documents.items.receipts")}</ListItem>
                                <ListItem>{t("customsPage.documents.items.proof")}</ListItem>
                            </List>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.finalization.title")}</Heading>
                            <Paragraph>{t("customsPage.finalization.text")}</Paragraph>
                        </SectionContainer>

                        <SectionContainer>
                            <Heading>{t("customsPage.timing.title")}</Heading>
                            <Paragraph>{t("customsPage.timing.text")}</Paragraph>
                        </SectionContainer>
                    </HeadingColumn>
                </Content>
            </Container>

            <Footer />
        </AnimationRevealPage>
    );
}
